import { createUrl } from 'shared/api/url';
import { getStandEnvironment } from 'shared/utils/stand';

import { samoletAuthConfig } from './config';

export class SamoletOAuthURLResolver {
  readonly standURL: string;

  constructor(useStagingEnvironment?: boolean) {
    if (useStagingEnvironment === undefined) {
      useStagingEnvironment = !getStandEnvironment().isProd;
    }

    this.standURL = useStagingEnvironment
      ? samoletAuthConfig.authStageStandUrl
      : samoletAuthConfig.authProdStandUrl;
  }

  getAuthTokenUrl() {
    return samoletAuthConfig.links.token.replace(':stand', `${this.standURL}`);
  }

  getJWTUrl() {
    return samoletAuthConfig.links.jwt.replace(':stand', `${this.standURL}`);
  }

  getRedirectCompleteUrl(): string {
    const { protocol, hostname, port }: Pick<Location, 'protocol' | 'port' | 'hostname'> =
      window.location;
    const url = `${protocol}//${hostname}${port ? ':' + port : ''}${
      samoletAuthConfig.links.complete
    }`;

    return createUrl(url, { toString: true });
  }

  createAuthUrl(params: { state: string; codeChallenge: string; clientId: string }) {
    const authUrl = new URL(
      samoletAuthConfig.links.auth.replace(':stand', `${this.standURL}`),
    );

    authUrl.searchParams.append('client_id', params.clientId);
    authUrl.searchParams.append('response_type', samoletAuthConfig.responseType);
    authUrl.searchParams.append('scope', samoletAuthConfig.scope);
    authUrl.searchParams.append(
      'code_challenge_method',
      samoletAuthConfig.codeChallengeMethod,
    );
    authUrl.searchParams.append('redirect_uri', this.getRedirectCompleteUrl());
    authUrl.searchParams.append('state', params.state);
    authUrl.searchParams.append('code_challenge', params.codeChallenge);

    return authUrl.href;
  }

  getLogoutUrl(redirectUrl?: string) {
    const logoutUrl = new URL(
      samoletAuthConfig.links.logout.replace(':stand', `${this.standURL}`),
    );
    const redirectPath = redirectUrl ?? window.location.origin;

    logoutUrl.searchParams.append('next', redirectPath);

    return logoutUrl.href;
  }
}
